import { SxProps } from "@mui/material";

export const sxTextField: SxProps = {
    input: {
      fontFamily: 'Unimed-Sans', 
      color: '#383838', 
      fontSize: '14px', 
    }
}